import { Link } from "react-router-dom";
import { useCompanies } from "@/hooks/useCompanies";

export default function CompaniesList() {
  const companies = useCompanies();

  return (
    <div className="space-y-6">
      <header className="flex items-center justify-between">
        <h1 className="text-3xl font-semibold">Companies</h1>
        <Link
          to="/dashboard/app/companies/new"
          className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
        >
          Add company
        </Link>
      </header>
      {companies.isLoading ? (
        <div className="text-muted-foreground">Loading…</div>
      ) : companies.data?.length ? (
        <ul className="divide-y rounded-lg border">
          {companies.data.map((company) => (
            <li key={company.id} className="flex items-center justify-between p-4">
              <div>
                <Link
                  to={`/dashboard/app/companies/${company.id}`}
                  className="font-medium hover:underline"
                >
                  {company.name}
                </Link>
                <div className="text-sm text-muted-foreground">
                  {company.country} · {company.company_type} · {company.currency}
                </div>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className="rounded-lg border p-8 text-center text-muted-foreground">
          No companies yet.{" "}
          <Link
            to="/dashboard/app/companies/new"
            className="text-foreground underline"
          >
            Add your first
          </Link>
        </div>
      )}
    </div>
  );
}
